import coworkUtils from "@/js/store/module/common/coworkUtils";
/**
 * 컨텐트블럭에 대한 공통메소드 정의
 */

const CHECK_AND_LAUNCH = coworkUtils.actions.CHECK_AND_LAUNCH;

const HW_KEYGEN = coworkUtils.actions.HW_KEYGEN;

let ContentBlockContext = {
  editor: { },
  progressScreen: null,
  initBoardEditor(editor, EventBus, SimpleModal) {
    let context = this;
    context.editor = editor;
    context.initContentBlock = (self) => {
      self.boardSection = editor.boardSection;
      self.tracelog = self.boardUtil.tracelog;
      if (editor.boardSection[0] === "SNAPSHOT") { 
        self.$nextTick(() => {
          let element = self.$refs.buttonComment;
          if (element) {
            element.style.display = "none";
            let btn = element.querySelector("button");
            element.removeChild(btn);
          }
        });
      }
      if (!self.contentBlockAPI) {
        self.contentBlockAPI = (sendId, param) => {
          let res = [];
          if (sendId == "updateBlock") {
            // console.log(/[<]img src=\"data:[a-zA-Z0-9/]+;base64,/g.exec(self.html));
            if (/[<]img src=\"data:[a-zA-Z0-9\/]+;base64,/g.exec(self.html)) {
              console.log("BASE64 BINARY FOUND!. NO-UPDATE!", self.bdata.paperBlockId);
              return;
            }
          }
          HW_KEYGEN({}, {head: "UPDT", res});
          let updateToken = res[0];
          self.boardUtil.addUpdateToken(updateToken);
          let params = {
            deleteBlock: {
              uri: "/block/deleteBlock",
              param: {
                paperId: String(self.paperInfo.paperId),
                groupId: String(self.paperInfo.groupId),
                paperBlockId: String(self.bdata.paperBlockId),
                fileId: self.bdata.fileId ? String(self.bdata.fileId) : null,
                sortNo: String(self.bdata.sortNo),
                blockMoveTo: param && param.blockMoveTo ? param.blockMoveTo : null,
                updateToken: updateToken
              },
              callback: param ? param.callback : null,
            },
            updateBlock: {
              uri: "/block/updateBlock",
              param: {
                paperId: String(self.paperInfo.paperId),
                paperBlockId: String(self.bdata.paperBlockId),
                blockType: self.bdata.blockType,
                sortNo: String(self.bdata.sortNo),
                blockLockYn: String(self.bdata.blockLockYn),
                // userName: String(self.bdata.blockLockName),
                content: self.bdata.blockType === self.BTPS().TODO || self.bdata.blockType === self.BTPS().DECISION  ?  self.bdata.contentPath : self.html,
                updateToken: updateToken
              },
              callback: param ? param.callback : null,
            }
          };
          self.boardUtil.apiCall(params[sendId]);
        };
      }
      if (!self.renderCompleted) {
        self.renderCompleted = (callback) => {
          if (self.$el) {
            CHECK_AND_LAUNCH({}, {
            check(ctx) {
              let pHeight = ctx.height;
              let cHeight = ctx.height = self.$el.offsetHeight;
              return cHeight > 0 && cHeight == pHeight;
            },
            launch(ctx) {
              if (self.$refs.dragHandle) {
                self.$refs.dragHandle.style.height = ctx.height + "px";
              }
              if (callback) {
                callback();
              }
            }});
          }
        };
      }
      if (!self.updateFileBlock) {
        self.updateFileBlock = () => {
          let apiParam = {
            uri: "/block/updateBlock",
            param: {
              paperId: String(self.paperInfo.paperId),
              paperBlockId: String(self.bdata.paperBlockId),
              blockType: self.bdata.blockType,
              sortNo: String(self.bdata.sortNo),
              blockState: String(self.bdata.blockState),
              userName: String(self.userInfo.userName),
              content: self.bdata.contentPath,
              fileId: self.bdata.fileId,
            }
          };
          self.boardUtil.apiCall(apiParam);
        };
      }
      if (!self.deleteBlock) {
        self.deleteBlock = (param) => {
          self.contentBlockAPI("deleteBlock", param);
        };
      }
      if (!self.focus) {
        self.focus = (forcely = false) => { self.boardUtil.ownBlock(self); };
      }
      if (!self.focusable) {
        self.focusable = () => { return false; };
      }
      if (!self.editorType) {
        self.editorType = () => { return false; };
      }
      if (!self.blur) {
        self.blur = () => { };
      }
      if (!self.cancelBlur) {
        self.cancelBlur = (fnc, arg) => {
          if (fnc && arg) { fnc(arg); }
          else if (fnc) { fnc(); }
        };
      }
      if (!self.setDisableEditable) {
        self.setDisableEditable = () => { };
      }
      if (!self.onConnected) {
        self.onConnected = () => { };
      }
      if (!self.stompEditorSubscribe) {
        self.stompEditorSubscribe = (command, bdata, error) => { return false; };
      }
      if (!self.downloadFile) {
        self.downloadFile = (e) => { self.context.downloadFile(self, e); };
      }
      if (!self.dragBlockState) {
        self.dragBlockState = (state) => { return context.dragBlockState(self, state); };
      }
      if (!self.getFileUrl) {
        self.getFileUrl = (uriOnly) => { return self.context.getFileUrl(self, uriOnly); };
      }
      if (!self.getContent) {
        self.getContent = () => { return self.bdata.contentPath; };
      }
      if (!self.checkLockOwn) {
        self.checkLockOwn = () => { return self.OTPS().NOBODY; };
      }
      if (!self.viewComment) {
        self.viewComment = () => { self.$emit("viewComment", self.bdata); } 
      };
      if (!self.blockIndex) {
        self.blockIndex = () => { return self.paperBlockIdList.indexOf(self.bdata.paperBlockId); };
      }
      if (!self.blockType) {
        self.blockType = () => { return self.bdata.blockType; };
      }

      if (!self.confirmModal) {
        self.confirmModal = context.confirmModal;
      }

      if (!self.deleteModal) {
        self.deleteModal = context.deleteModal;
      }

      if (!self.alertModal) {
        self.alertModal = context.alertModal;
      }

      if (!self.toast) {
        self.toast = context.toast;
      }

      if (!self.uploadFile) {
        self.uploadFile = editor.uploadFile;
      }

      if (!self.registerBlockTrigger) {
        self.registerBlockTrigger = (paperBlockId, callback) => {
          editor.registerBlockTrigger(paperBlockId, callback);
        };
      }

      if (!self.paperBlockContentRequest) {
        self.paperBlockContentRequest = (idList, lockMap, callbackChain) => {
          editor.paperBlockContentRequest(idList, lockMap, callbackChain);
        };
      }

      if (!self.reloadContentBlocks) {
        self.reloadContentBlocks = editor.reloadContentBlocks;
      }

      if (!self.BTPS) {
        self.BTPS = () => { return self.boardUtil.blockTypes; };
      }
      if (!self.btps) { self.btps = self.boardUtil.blockTypes; }

      if (!self.OTPS) {
        self.OTPS = () => { return self.boardUtil.ownTypes; };
      }
      if (!self.otps) { self.otps = self.boardUtil.ownTypes; }

      if (!self.$dm) {
        self.$dm = (e, a) => { return self.boardUtil.$dm(e, a); };
      }
    },
    context.eventBusProc = (self) => {
      EventBus.$on("contentBlockMatched", payload => {
        if (
          payload &&
          payload.paperId === self.paperInfo.paperId &&
          payload.paperBlockId === self.bdata.paperBlockId
        ) {
           // 보드전체의견레이어에서 의견클릭시 보드블럭 이동시 이미 하이라이트 되어있던 블럭 클래스 제거
           if (self.paperBlockIdList && self.paperBlockIdList.length > 0) {
            for (let inx = 0; inx < self.paperBlockIdList.length; inx++) {
              let elem = self.paperBlockMap[self.paperBlockIdList[inx]].element;
              if (elem && elem.$el.classList.contains("comment_highlight")) {
                elem.$el.classList.remove("comment_highlight");
                if (payload.commentId != null && elem.bdata.boardCommentId != payload.commentId) {
                  elem.bdata.boardCommentId = null;
                }
              }
            }
          }
          let elem = self.paperBlockMap[payload.paperBlockId].element;
          if (elem && (elem = elem.$el)) {
            // if (self.bdata.boardCommentId !== payload.commentId) {
              let scrollX = window.scrollX || window.pageXOffset;
              let scrollY = window.scrollY || window.pageYOffset;
              
              scrollY = elem.offsetTop - (elem.clientHeight < 10 ? 15 : elem.clientHeight) - (93 + 68);
              if (scrollY > 79) { scrollY -= 79; }
              if (scrollY < 0) { scrollY = 0; }
              
              window.scrollTo(scrollX, scrollY);
              elem.classList.add("comment_highlight");
              self.bdata.boardCommentId = payload.commentId;
            // }
            // else {
              // self.bdata.boardCommentId = null;
            // }
          }
        }
      });

      EventBus.$on("copaper.comment", param => {
        if (param.action === "count" && param.paperBlockId === self.bdata.paperBlockId) {
          self.commentCount = param.count;
        }
      });

      EventBus.$on("closeDeciBlock", payload => {
        if (payload === self.bdata.paperBlockId){
        let el = self.$refs.opinionForm;
          el.classList.toggle("hidden");
          self.decisionBlockKey += 1;
        }
      });

      EventBus.$on("removeBlockHighlight", payload => { 
        if (
          payload &&
          payload.paperId === self.paperInfo.paperId
        ) {
          if (self.paperBlockIdList && self.paperBlockIdList.length > 0) {
            for (let inx = 0; inx < self.paperBlockIdList.length; inx++) {
              let elem = self.paperBlockMap[self.paperBlockIdList[inx]].element;
              if (elem && elem.$el.classList.contains("comment_highlight")) {
                elem.$el.classList.remove("comment_highlight");
                // break;
              }
            }
          } 
        }
      });
    };

    context.downloadFile = (self, e) => {
      self.$axios({
        url: "/api/cofile/cofile/download",
        responseType: "blob",
        headers: { "Content-Type": "application/json" },
        method: "post",
        data: {
          type: "SINGLE",
          groupId: self.paperInfo.groupId,
          groupKbn: self.paperInfo.groupInfo.groupKbn,
          fileId: String(self.bdata.fileId)
        }
      })
      .then(res => {
        try {
          let fileName = String(self.bdata.contentPath);
          let blob = new Blob([res.data], {
            type: res.headers["content-type"]
          });

          // 에러코드 체크
          if(res.data.type.startsWith("application/json")) {
            let u, x;
            u = URL.createObjectURL(blob);
            x = new XMLHttpRequest();
            x.open('GET', u, false);
            x.send();
            URL.revokeObjectURL(u);

            let errorCode = x.responseText;
            if(errorCode == "NOT_AUTHORIZED") {
              self.notAuthorizedDownloadFail();
              return;
            } else if(errorCode == "COFILE_FILE_DOWNLOAD_DENIED_FROM_EXTERNAL") {
              self.noticeDownloadFailFromExternal();
              return;
            } else {
              self.noticeDownloadFail();
              return;
            }
          }

          if (window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, fileName);
          }
          else {
            let link = document.createElement("a");
            link.target = "_self";
            link.setAttribute("download", fileName);
            link.href = window.URL.createObjectURL(blob);
            link.click();
            link.remove();
          }
        }
        catch (e) {
          self.noticeDownloadFail();
          console.error(e);
        }
      })
      .catch(res => {
        self.noticeDownloadFail();
        console.log(res);
      });
    };

    context.dragBlockState = (self, state) => {
      /* 2021.12.01 BoardEditor.vue .sortable-chosen style로 대신함 */
      // let style = self.$el.style;
      // if (state === 1) {
      //   style.opacity = 0.5;
      // }
      // else {
      //   style.opacity = "";
      // }
    };

    context.getFileUrl = (self, uriOnly) => {
      let groupId = self.paperInfo.groupId;
      let fileId = String(self.bdata.fileId);
      let url = "";
      if (!uriOnly) {
        let curl = window.location.href;
        let match = /^((http|https):\/\/([a-zA-Z0-9.]+)([:][0-9]+){0,1})(\/.*){0,1}/.exec(curl);
        if (match.length > 1) {
          url = match[1];
        }
      }
      return url + "/general/viewer/" + groupId + "/" + fileId;
    };

    context.showProgress = (maxTime = -1, fncFallback) => {
      // console.log("SHOW:", context.progressScreen, context.progressScreenTimeout);
      if (context.progressScreen || context.progressScreenTimeout) {
        context.hideProgress();
      }
      context.progressScreen = context.editor.$loading.show();
      if (maxTime != -1 && maxTime > 0) {
        context.progressScreenTimeout = setTimeout(() => {
          context.hideProgress();
          if (fncFallback) {
            fncFallback();
          }
        }, maxTime);
      }
    };

    context.hideProgress = () => {
      // console.log("HIDE:", context.progressScreen, context.progressScreenTimeout);
      if (context.progressScreenTimeout) {
        clearTimeout(context.progressScreenTimeout);
        delete context.progressScreenTimeout;
      }
      if (context.progressScreen) {
        context.progressScreen.hide();
        context.progressScreen = null;
      }
    };

    context.confirmModal = (msg, callback, labels) => {
      if (!labels) { labels = [{},{}]; }
      for (let inx in [0, 1]) {
        labels[inx] = labels[inx] || {};
      }
      const modalInfo = {
        obj: editor.$modal,
        component: SimpleModal,
        width: "300px",
        modalContent: msg,
        btnList: [ 
          { label: labels[0].text || editor.$t("button.cancel"), class: labels[0].cls || "btn_ty2", click(modal) { modal.close(); }},
          { label: labels[1].text || editor.$t("button.confirm"), class: labels[1].cls || "btn_ty1", click: callback },
        ]
      };
      editor.showModal(modalInfo);
    };

    context.deleteModal = (msg, callback) => {
      const modalInfo = {
        obj: editor.$modal,
        component: SimpleModal,
        width: "300px",
        modalContent: msg,
        btnList: [ 
          { label: editor.$t("button.cancel"), class: "btn_ty2", click(modal) { modal.close(); }},
          { label: editor.$t("button.delete"), class: "btn_ty1", click: callback },
        ]
      };
      editor.showModal(modalInfo);
    };

    context.alertModal = (msg) => {
      const modalInfo = {
        obj: editor.$modal,
        component: SimpleModal,
        width: "300px",
        modalContent: msg,
        btnList: [ { label: editor.$t("button.confirm"), class: "btn_ty1", click(modal) { modal.close(); }} ]
      };
      editor.showModal(modalInfo);
    };

    context.toast = (toastMsg) => {
      let toastInfo = {
        obj: editor.$toasted,
        message: toastMsg,
        options: { theme: "toasted-primary", position: "bottom-left", duration: 3000, },
      };
      editor.showToast(toastInfo);
    };

    if (!editor.confirmModal) {
      editor.confirmModal = context.confirmModal;
    }
    if (!editor.deleteModal) {
      editor.deleteModal = context.deleteModal;
    }
    if (!editor.alertModal) {
      editor.alertModal = context.alertModal;
    }
    if (!editor.toast) {
      editor.toast = context.toast;
    }
  }
}

export default ContentBlockContext 


// WEBPACK FOOTER //
// ./src/components/cowork/general/board/editor/ContentBlockContext.js